import React, { useContext } from 'react';
import NavBar from '../components/NavBar';
import SubscriptionForm from '../components/SubscriptionForm';
import { LanguageContext } from '../LanguageContext';
import '../App.css';

function Contact() {
  const { t } = useContext(LanguageContext);

  return (
    <div>
      <NavBar />
      {/* <div className="page-content">
        <h1>{t('contact') || 'Contact'}</h1>
        <div className="text-section" style={{ textAlign: 'center' }}>
          <p>
            {t('emailinfo')} <a href="mailto:halfsermonministries@gmail.com">halfsermonministries@gmail.com</a>
          </p>
        </div>
      </div> */}
      <SubscriptionForm />
    </div>
  );
}

export default Contact;
